var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"QandA"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.i18n('21'))+" ")]),_c('div',{staticClass:"inner"},_vm._l((_vm.listData),function(item,index){return _c('qaItem',{key:index,attrs:{"data":item}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }